/* Dorum Editorial — minimal theme behaviour (no framework) */
(() => {
  const money = (cents, format) => {
    const lang = document.documentElement.lang || 'pt-PT';
    const plain = (min, max, group) =>
      (cents / 100).toLocaleString(lang, {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
        useGrouping: group,
      });
    const fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_m, key) => {
      switch (key) {
        case 'amount_no_decimals':
        case 'amount_no_decimals_with_comma_separator':
        case 'amount_no_decimals_with_space_separator':
          return plain(0, 0, true);
        default:
          return plain(2, 2, true);
      }
    });
  };

  /* Variant selection on the product form */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const data = form.querySelector('[data-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const selects = form.querySelectorAll('[data-option-index]');
    const idInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-price]');
    const submit = form.querySelector('[type="submit"]');
    const format = form.dataset.moneyFormat;

    const update = () => {
      const chosen = Array.from(selects).map((s) => s.value);
      const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i])) || variants[0];
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_money || money(variant.price, format);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.labelAvailable : submit.dataset.labelSoldOut;
      }
    };

    selects.forEach((s) => s.addEventListener('change', update));
    update();
  });

  /* Accessible horizontal scrollers keep keyboard focus */
  document.querySelectorAll('[data-scroller]').forEach((el) => {
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
  });
})();

/* Alternar entre entrar e recuperar password */
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-auth-toggle]');
  if (toggle) {
    var login = document.getElementById('LoginPanel');
    var recover = document.getElementById('RecoverPassword');
    if (login && recover) {
      var showRecover = toggle.getAttribute('data-auth-toggle') === 'recover';
      recover.style.display = showRecover ? 'block' : 'none';
      login.style.display = showRecover ? 'none' : 'block';
      var focusTarget = showRecover
        ? document.getElementById('RecoverEmail')
        : document.getElementById('LoginEmail');
      if (focusTarget) focusTarget.focus();
    }
    return;
  }

  var del = event.target.closest('[data-address-delete]');
  if (del) {
    var message = del.getAttribute('data-confirm') || 'Delete?';
    if (!window.confirm(message)) event.preventDefault();
  }
});

/* Mostrar o painel de recuperação quando o Shopify devolve #recover */
if (window.location.hash === '#recover') {
  document.addEventListener('DOMContentLoaded', function () {
    var login = document.getElementById('LoginPanel');
    var recover = document.getElementById('RecoverPassword');
    if (login && recover) {
      recover.style.display = 'block';
      login.style.display = 'none';
    }
  });
}

/* ------------------------------------------------------------------
   Favoritos (wishlist) — guardado no dispositivo, sem dependências
------------------------------------------------------------------ */
(() => {
  const KEY = 'dorum:favorites';
  const strings = (window.theme && window.theme.strings) || {};
  const heart = (fill) =>
    `<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="${fill ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20s-7.5-4.3-7.5-9.2A4.3 4.3 0 0 1 12 8a4.3 4.3 0 0 1 7.5 2.8C19.5 15.7 12 20 12 20Z"/></svg>`;
  const HEART = heart(false);
  const HEART_FILLED = heart(true);

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter((i) => i && i.handle) : [];
    } catch (e) {
      return [];
    }
  };
  const write = (items) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* armazenamento indisponível (modo privado) */
    }
  };

  const updateCount = (items) => {
    document.querySelectorAll('[data-favorites-count]').forEach((el) => {
      el.textContent = items.length;
      el.hidden = items.length === 0;
    });
  };

  const syncButtons = (items) => {
    const handles = items.map((i) => i.handle);
    document.querySelectorAll('[data-favorite-toggle]').forEach((btn) => {
      const on = handles.indexOf(btn.dataset.handle) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      const label = btn.querySelector('[data-favorite-label]');
      if (label) label.textContent = on ? strings.favoriteRemove || label.textContent : strings.favoriteAdd || label.textContent;
      if (!label) {
        btn.setAttribute('aria-label', on ? strings.favoriteRemove || '' : strings.favoriteAdd || '');
      }
    });
  };

  const renderPage = (items) => {
    const grid = document.querySelector('[data-favorites-grid]');
    const empty = document.querySelector('[data-favorites-empty]');
    if (!grid) return;
    grid.innerHTML = items
      .map(
        (item) => `
        <div class="card" data-product-handle="${item.handle}">
          <a class="card__media" href="${item.url}" tabindex="-1" aria-hidden="true">
            ${item.image ? `<img src="${item.image}" alt="" width="500" height="500" loading="lazy">` : ''}
          </a>
          <button type="button" class="card__fav is-active" data-favorite-toggle
            data-handle="${item.handle}" data-title="${item.title}" data-url="${item.url}"
            data-image="${item.image || ''}" data-price="${item.price || ''}" aria-pressed="true"
            aria-label="${strings.favoriteRemove || 'Remover'}">
            <span class="card__fav-off">${HEART}</span>
            <span class="card__fav-on">${HEART_FILLED}</span>
          </button>
          <div class="card__body">
            <h3 class="card__title"><a href="${item.url}">${item.title}</a></h3>
            ${item.price ? `<p class="price">${item.price}</p>` : ''}
            <a class="btn btn--outline btn--full" href="${item.url}">${strings.viewProduct || 'Ver'}</a>
          </div>
        </div>`
      )
      .join('');
    grid.hidden = items.length === 0;
    if (empty) empty.hidden = items.length > 0;
  };

  const refresh = () => {
    const items = read();
    updateCount(items);
    syncButtons(items);
    renderPage(items);
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    event.preventDefault();
    const items = read();
    const index = items.findIndex((i) => i.handle === btn.dataset.handle);
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.unshift({
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        url: btn.dataset.url,
        image: btn.dataset.image,
        price: btn.dataset.price,
      });
    }
    write(items);
    refresh();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === KEY) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();

/* Contador do carrinho sempre atualizado (após voltar do checkout / cache) */
(() => {
  const paint = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };
  const fetchCart = () => {
    fetch((window.theme && window.theme.routes && window.theme.routes.cart) ? window.theme.routes.cart + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (cart && typeof cart.item_count === 'number') paint(cart.item_count);
      })
      .catch(() => {});
  };
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') fetchCart();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) fetchCart();
  });
  fetchCart();
})();

/* ------------------------------------------------------------------
   Drawer do carrinho — abre ao tocar no ícone, sem checkout online
------------------------------------------------------------------ */
(() => {
  const drawer = () => document.querySelector('[data-cart-drawer]');
  let lastFocus = null;

  const open = () => {
    const el = drawer();
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('drawer-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = el.querySelector('[data-drawer-close], a, button');
    if (focusable) focusable.focus();
  };

  const close = () => {
    const el = drawer();
    if (!el || el.hidden) return;
    el.hidden = true;
    document.body.classList.remove('drawer-open');
    document.querySelectorAll('[data-cart-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && drawer()) {
      event.preventDefault();
      const el = drawer();
      el.hidden ? open() : close();
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();

/* Carrosséis horizontais: setas e estado das extremidades.
   O deslize com o dedo é nativo (scroll-snap), sem JavaScript. */
(function () {
  function railFor(button) {
    var id = button.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function step(rail) {
    var first = rail.firstElementChild;
    if (!first) return rail.clientWidth;
    var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function sync(rail) {
    var prev = document.querySelector('[data-rail-prev][aria-controls="' + rail.id + '"]');
    var next = document.querySelector('[data-rail-next][aria-controls="' + rail.id + '"]');
    var max = rail.scrollWidth - rail.clientWidth - 1;
    if (prev) prev.disabled = rail.scrollLeft <= 0;
    if (next) next.disabled = rail.scrollLeft >= max;
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-rail]').forEach(function (rail) {
      if (rail.dataset.railReady) return;
      rail.dataset.railReady = 'true';
      var update = function () { sync(rail); };
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-rail-prev], [data-rail-next]');
    if (!button) return;
    var rail = railFor(button);
    if (!rail) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({
      left: button.hasAttribute('data-rail-next') ? step(rail) : -step(rail),
      behavior: reduce ? 'auto' : 'smooth'
    });
  });

  init(document);
  /* O editor de temas volta a montar a secção sem recarregar a página. */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Painel de menu do cabeçalho: o mesmo painel para o botão Menu (desktop)
   e para o hambúrguer (mobile). */
(function () {
  function setOpen(panel, open) {
    panel.hidden = !open;
    document
      .querySelectorAll('[data-menu-toggle][aria-controls="' + panel.id + '"]')
      .forEach(function (btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (panel) setOpen(panel, panel.hidden);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header__panel:not([hidden])').forEach(function (panel) {
      setOpen(panel, false);
      var btn = document.querySelector('[data-menu-toggle][aria-controls="' + panel.id + '"]');
      if (btn) btn.focus();
    });
  });
})();

/* Hero: banner deslizante. O arrastar é nativo (scroll-snap); aqui só os
   pontos de navegação e a rotação automática opcional. */
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-hero-track]').forEach(function (track) {
      if (track.dataset.heroReady) return;
      track.dataset.heroReady = 'true';

      var root = track.closest('.hero-slider');
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hero-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
      if (slides.length < 2 || !dots.length) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var index = 0;

      function paint() {
        dots.forEach(function (dot, n) {
          if (n === index) { dot.setAttribute('aria-current', 'true'); }
          else { dot.removeAttribute('aria-current'); }
        });
      }
      function sync() {
        if (!track.clientWidth) return;
        var next = Math.round(track.scrollLeft / track.clientWidth);
        if (next !== index) { index = next; paint(); }
      }
      function go(next) {
        index = (next + slides.length) % slides.length;
        track.scrollTo({ left: index * track.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
        paint();
      }

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          go(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0);
        });
      });

      var seconds = parseInt(root.getAttribute('data-hero-autoplay'), 10);
      if (!(seconds > 0) || reduce.matches) return;
      var timer = null;
      var halted = false;
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (halted) return; stop(); timer = setInterval(function () { go(index + 1); }, seconds * 1000); }
      /* WCAG 2.2.2: depois de o visitante mexer no carrossel, a rotação não
         volta a arrancar sozinha. */
      function halt() { halted = true; stop(); }
      ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
        root.addEventListener(evt, halt, { once: true, passive: true });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* Barra de posição de qualquer lista que se arrasta na horizontal.
   O elemento aponta para o scroller com data-progress-for="<id>". */
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-progress-for]').forEach(function (track) {
      if (track.dataset.progressReady) return;
      track.dataset.progressReady = 'true';

      var rail = document.getElementById(track.getAttribute('data-progress-for'));
      var bar = track.firstElementChild;
      if (!rail || !bar) return;

      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        /* Nada para arrastar: a barra não tem o que indicar. */
        if (max <= 1 || !track.clientWidth) { track.hidden = true; return; }
        track.hidden = false;
        var width = Math.max((rail.clientWidth / rail.scrollWidth) * track.clientWidth, 24);
        var travel = track.clientWidth - width;
        bar.style.width = width + 'px';
        bar.style.transform = 'translateX(' + (rail.scrollLeft / max) * travel + 'px)';
      }

      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      /* A lista muda de tamanho depois do primeiro cálculo: tipos de letra a
         trocar, imagens a chegar, o editor a voltar a montar a secção. Sem
         isto a barra podia ficar escondida numa lista que já se arrasta. */
      if (typeof ResizeObserver === 'function') {
        var ro = new ResizeObserver(update);
        ro.observe(rail);
        if (rail.firstElementChild) ro.observe(rail.firstElementChild);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
      window.addEventListener('load', update);

      update();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
